import { render, staticRenderFns } from "./sintegra.vue?vue&type=template&id=47ee69fa&scoped=true&"
import script from "./sintegra.vue?vue&type=script&lang=js&"
export * from "./sintegra.vue?vue&type=script&lang=js&"
import style0 from "./sintegra.vue?vue&type=style&index=0&id=47ee69fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ee69fa",
  null
  
)

export default component.exports